import { branch } from '../constants'

module.exports = (transaction) ->
  configBranch = await Weaver.Branch.load(branch)
  await configBranch.protect() if !configBranch.isProtected()
